import { Header } from '@components-deprecated'

import { Button, ButtonsGroup, Flex, Space, Spacing, Text } from '@billy/design-system'
import styled from '@emotion/styled'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { useBankIntegration } from '@features/openBanking/contexts/bankIntegrationContext'
import { useInitiateOpenBankingConnection } from '@features/openBanking/hooks/useInitiateOpenBankingConnection'
import { UiSource } from '@features/reconciliation/enums'

import { SpecificState } from '../../../types/reduxSaga-deprecated'
import { BankAccountSelector } from '../../app'
import { bankAccountSelected } from '../../app/accounts/action-creators'
import { Account } from '../../app/accounts/types'

export type ModuleHeaderProps = {
  onConnectBankAccount: () => void
  onImport: () => void
  organizationId: string
}

// TODO retheming 2026 - get rid of (Text), which is an antipattern
const AccountSelectorTitle = styled(Text)`
  margin-top: -${Spacing.S4};
  margin-right: ${Spacing.S12};
  align-self: center;
`

export const ModuleHeader = ({ onConnectBankAccount, onImport, organizationId, ...rest }: ModuleHeaderProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const account = useSelector((state: SpecificState) => state.app.account) as Account
  const { connectedBankAccountId } = useBankIntegration()
  const { connectToOpenBanking } = useInitiateOpenBankingConnection(UiSource.OldReconAddAccountDropdown)

  const handleSplitButtonAction = useCallback(
    (value: string) => {
      if (value === 'connect-bank-account') {
        connectToOpenBanking()
      } else if (value === 'import') {
        onImport()
      }
    },
    [connectToOpenBanking, onImport],
  )

  return (
    <Header title={t('bankreconciliation')} {...rest}>
      <Flex justifyContent="flex-end">
        <AccountSelectorTitle colorVariant="secondary">
          {t('bankreconciliation.header.bankaccounts')}:
        </AccountSelectorTitle>
        <BankAccountSelector
          preselectedId={account?.id}
          onItemSelect={(account: Account) => dispatch(bankAccountSelected(account))}
        />
      </Flex>
      <Space />
      {connectedBankAccountId ? (
        <Button onClick={onImport} variant="outlined">
          {t('bankreconciliation.header.import')}
        </Button>
      ) : (
        <ButtonsGroup>
          <Button onClick={() => handleSplitButtonAction('connect-bank-account')}>
            {t('bankreconciliation.header.connectyourbank')}
          </Button>
          <Button onClick={() => handleSplitButtonAction('import')} variant="outlined">
            {t('bankreconciliation.header.import')}
          </Button>
        </ButtonsGroup>
      )}
    </Header>
  )
}
